<template>
  <nav class="pagination" v-show="total > 0">
    <a
      class="pagination-btn"
      :class="{ disabled: isPrevDisabled() }"
      @click="!isPrevDisabled() ? handlePrev() : null"
      >
        <icon
          type="iconic_back"
          class="pagination-btn-prev"
        ></icon>
      </a
    >
    <a
      class="pagination-btn"
      :class="{
        disabled: isPageDisabled(item),
        active: item === page,
      }"
      v-for="(item, index) in pages"
      :key="index"
      @click="!isPageDisabled(item) ? handleSetPage(item) : null"
      >{{ item }}</a
    >
    <a
      class="pagination-btn"
      :class="{ disabled: isNextDisabled() }"
      @click="!isNextDisabled() ? handleNext() : null"
      >
        <icon
          type="iconic_back"
          class="pagination-btn-next"
        ></icon>
    </a>
  </nav>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      default: 0,
    },
    size: {
      type: [Number, String],
      default: 10,
    },
    page: {
      type: Number,
      default: 1,
    },
  },

  computed: {
    maxPage() {
      const { total, size } = this;
      return Math.ceil(total / size);
    },

    // 生成页数
    pages() {
      const { maxPage, page } = this;

      let pages = [];
      // 小于等于8页直接展示
      if (maxPage <= 8) {
        for (let i = 0; i < maxPage; i++) {
          pages.push(i + 1);
        }
      }
      // 大于8页需要做缩略展示
      else {
        // 在当前页数小于6的情况下，往右省略
        if (page < 6) {
          pages = [1, 2, 3, 4, 5, 6, '...', maxPage - 1, maxPage];
        }
        // 在当前页数大于倒数第六页的情况下，往左省略
        else if (page > maxPage - 5) {
          pages = [
            1,
            2,
            '...',
            maxPage - 5,
            maxPage - 4,
            maxPage - 3,
            maxPage - 2,
            maxPage - 1,
            maxPage,
          ];
        } else {
          pages = [
            1,
            2,
            '...',
            page - 2,
            page - 1,
            page,
            page + 1,
            page + 2,
            '...',
            maxPage - 1,
            maxPage,
          ];
        }
      }

      return pages;
    },
  },

  methods: {
    isPageDisabled(page) {
      return page === '...' || page === this.page;
    },

    isNextDisabled() {
      return this.page >= this.maxPage;
    },

    isPrevDisabled() {
      return this.page <= 1;
    },

    handleSetPage(page) {
      this.$emit('change', page);
    },

    handlePrev() {
      this.$emit('change', this.page - 1);
    },

    handleNext() {
      this.$emit('change', this.page + 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;

  &-btn {
    color: #333840;
    font-size: 14px;
    position: relative;
    padding: 1px 6px;
    line-height: 22px;
    text-decoration: none;
    border-radius: 4px;
    cursor: pointer;
    min-width: 32px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;

    &:not(:last-of-type) {
      margin-right: 4px;
    }

    &:hover {
      background: rgba(8, 48, 93, 0.04);
      color: #333840;
    }

    &:active:not(:disabled) {
      color: #111317;
      background: rgba(8, 48, 93, 0.08);
    }

    &.disabled {
      background-color: #fff;
      cursor: not-allowed;
    }

    &.active {
      background: #2C71FA;
      color: #fff;
      &:active:not(:disabled) {
        background: #2C71FA;
      }
    }

    &-prev, &-next {
      font-size: 14px;
      color: #333840;
    }

    &-next {
      transform: rotate(180deg);
    }
  }
}
</style>
